<template>
  <div id="products">
    <call />
    <pop-alert />
    <!-- header -->
    <header>
      <header-app :rate="counterBlock" :canMobileOrder="isMobileOrderEnabled()"></header-app>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>
    <!-- main -->
    <main>
      <!-- notice -->
      <section v-if="dataReady">
        <div class="l-main l-main--bg-border l-main--no-pd-bot l-main--bg-border--green pt-60" v-if="dataReady">
          <div class="l-main__head">
            <router-link :to="backlink" class="l-main__head--control l-main__head--control--back">
              <img src="/assets/images/icon/icon-back-white.svg?v=2" alt="">
            </router-link>
            <div class="l-main__head--title">{{tenant && tenant.shopName}}</div>
            <router-link :to="backlink" class="l-main__head--control l-main__head--control--close">
              <img src="/assets/images/icon/icon-close-black.svg" alt="">
            </router-link>
          </div>
          <div class="l-pickup-detail">
            <div class="l-pickup-detail__img-wrap">
              <div class="l-pickup-detail__img">
                <img :src="getImgSrc(getShopImage())" alt="">
              </div>
            </div>
            <div class="handling-labels" v-if="!tenant.enableTimebaseReservation">
              <span class="handling-format-label togo" v-if="type == 'pickup' && tenant.handlingFormatToGo && tenant.handlingFormatToGo.enabled">お持ち帰り</span>
              <span class="handling-format-label forhere" v-if="type == 'pickup' && tenant.handlingFormatForHere && tenant.handlingFormatForHere.enabled">店内でお食事</span>
              <span class="handling-format-label drivethru" v-if="type == 'drivethru' && tenant.handlingFormatDeliveryLane && tenant.handlingFormatDeliveryLane.enabled">ドライブスルー</span>
              <span class="handling-format-label parkandpickup" v-if="type == 'parkandpickup' && tenant.handlingFormatDeliveryParking && tenant.handlingFormatDeliveryParking.enabled">駐車場受け取り</span>
              <span class="handling-format-label reservation" v-if="type == 'reservation' && tenant.handlingFormatReservation && tenant.handlingFormatReservation.enabled">ご来店予約</span>
            </div>
            <div class="l-pickup-detail__info">
              <div class="c-estimated-group c-estimated-group--xl" v-if="tenant && isOrderEnabled(tenant, type, $store.state.userId) && isEnableTimebase(tenant)">
                <div class="c-estimated c-estimated-horizon">
                  <img src="/assets/images/icon/icon-clock.svg" alt="">{{type == 'reservation' ? '待ち時間目安' : '受け取り目安'}} </div>
                <div v-if="setting" class="c-estimated-time">
                  <small>{{type == 'reservation' ? 'ご予約後' : '注文後'}}</small> 約{{ setting.standardServiceTime }}分
                </div>
              </div>
              <div class="c-estimated-group c-estimated-group--xl" v-if="tenant && !isOrderEnabled(tenant, type, $store.state.userId)">
                <div class="c-estimated-time">
                  ただいまの時間は受け付けておりません。
                </div>
              </div>
              <hr>
              <div class="l-pickup-detail__time">
                <div class="d-flex justify-content-space">
                  <div>
                    <h3>{{ orderType }}<span v-if="tenant.enableTimebaseReservation">予約</span>受付時間</h3>
                    <span v-html="acceptTime"></span>
                  </div>
                  <span>
                    <div v-if="follows.includes(tenant.id)" class="c-btn-follow is-active" v-on:click="deleteFollows(tenant.id)">
                      <span class="c-btn-follow__active">フォロー中</span>
                    </div>
                    <div v-else class="c-btn-follow" v-on:click="addFollows(tenant.id)">
                      <span class="c-btn-follow__unactive">フォローする</span>
                    </div>
                  </span>
                </div>
              </div>
              <div class="mb-8" v-if="type == 'pickup' && isPriceNoticeRequired(tenant)">
                <p>※「お持ち帰り」と「店内でお食事」の商品は同時購入できません</p>
              </div>
              <div class="mb-8" v-if="type == 'pickup' && isPriceNoticeRequired(tenant)">
                <p>※軽減税率制度により「お持ち帰り」または「店内でお食事」にて税込価格表示が異なります </p>
              </div>
              <div clas="mb-8" v-if="type == 'pickup' && isPriceNoticeRequired(tenant)">
                <p>※商品提供方法がお持ち帰りの場合、容器代等が加わり商品単価が変わる場合があります</p>
              </div>
              <div v-show="!show_more_detail" class="text-center">
                <button class="l-pickup-detail_button" v-on:click="showDetailMore(true)">店舗場所 / 営業時間 / 連絡先</button>
              </div>
              <div  v-show="show_more_detail">
                <div class="text-right">
                  <button  class="l-pickup-detail_button close" v-on:click="showDetailMore(false)">閉じる</button>
                </div>
                <div class="l-pickup-detail__info-detail" >
                  <span v-if="tenant.location">場所　　　　　　：{{tenant.location}}</span><br>
                  <span v-if="tenant.floorGuideNo">フロアガイド番号：{{tenant.floorGuideNo}}</span><br>
                  <span v-if="tenant.businessHour">
                  営業時間：{{ tenant.businessHour.from }}〜{{ tenant.businessHour.to }}<br />
                  </span>
                  <span v-if="tenant.businessHourBusinessDay">
                  営業時間（平日）：{{ tenant.businessHourBusinessDay.from }}〜{{ tenant.businessHourBusinessDay.to }}<br />
                  </span>
                  <span v-if="tenant.businessHourHoliday">
                  営業時間（土日祝）：{{ tenant.businessHourHoliday.from }}〜{{ tenant.businessHourHoliday.to }}<br />
                  </span>
                  <span>連絡先　　　　　：{{tenant.tel}}</span>
                </div>
                <div class="d-flex">
                  <div class="l-pickup-detail__control" v-if="showFloorGuide">
                    <router-link to="/store/floorguide" class="c-btn-check" v-on:click="floorGuideUrl(tenant.data().floorGuideUrl)"><img src="/assets/images/icon/icon-map-grey.svg"
                      alt="" />フロアガイドで確認</router-link>
                  </div>
                  <div class="l-pickup-detail__control specified">
                    <a href="#" @click.prevent="openCommercialLawPopup" class="c-btn-check">特定商取引法に<br />基づく表記</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="l-list-menu" v-if="tags && tags.length">
            <div class="l-list-menu__title">Menu</div>
            <div class="l-list-menu__tab">
              <!-- swiper_tab -->
              <div class="swiper-container c-tab-menu js-swiper_tab">
                <div class="swiper-wrapper c-tab-menu__wrap">
                  <div v-for="(tag, index) in tags" :key="index" class="swiper-slide c-tab-menu__item"
                    v-bind:class="{ 'is-active': index === 0 }">{{ tag.name }}</div>
                </div>
              </div>
              <!-- js-_body -->
              <div class="swiper-container js-swiper_tab_body">
                <div class="swiper-wrapper" v-if="tags">
                  <div v-for="(tag, idx) in tags" class="swiper-slide" :key="idx">
                    <ul class="c-list-menu">
                      <li v-for="(product, index) in tag.products"  :key="index" >
                        <div v-if="checkShowItem(tenant,product)" class="c-list-menu__item_wrapper">
                          <div class="c-list-menu__item">
                            <div v-on:click="redirectToProductDetail(product.id)" class="c-list-menu__info">
                              <div class="c-list-menu__img product-image">
                               <img v-bind:src="getImgSrc(product.image && product.image[0])" v-bind:alt="product.productName">
                              </div>
                              <div class="c-list-menu__info-detail">
                                <h1 class="c-list-menu__info-name">{{ product.productName }}</h1>
                                <p v-html="autolink(product.description)"></p>
                              </div>
                            </div>
                            <div class="c-list-menu__control">
                              <div v-on:click="redirectToProductDetail(product.id)" class="c-list-menu__control--left">
                                <div class="c-price-product" v-if="!product.sale && getPrice(product) > 0">
                                  {{ priceFormat(getProductPriceTaxed(product, type, tenant)) }}<small>円（税込）</small>
                                </div>
                                <div v-else-if="getPrice(product) > 0" class="c-price-product sale">
                                  <span class="sale-original">{{ priceFormat(getProductPriceTaxed(product, type, tenant)) }}<small>円（税込）</small></span><br />
                                  <small>SALE：</small>{{ priceFormat(getProductSalePriceTaxed(product, type, tenant)) }}<small>円（税込）</small>
                                </div>
                              </div>
                              <div class="c-list-menu__control--right">
                                <div :class="{'c-btn-add-cart': true, 'c-btn-reservation': type == 'reservation' }" v-if="!product.soldout" @click.prevent="showOption(product.id)">
                                  {{ type == 'reservation' ? 'リストへ追加' : 'カートに追加' }}
                                </div>
                                <div v-else class="c-btn-add-cart soldout" @click="showSoldout()">
                                  SOLDOUT
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer-cart></footer-cart>
       <alert :message="alert_msg" 
        :show="alert_show" 
        :closeModal="closeModal" 
        :confirm_show="confirm_show" 
        :confirm_message="confirm_msg" 
        :confirm_callback="confirm_callback" 
        :confirm_hide_cancel="confirm_hide_cancel"
        :label_cancel="confirm_label_cancel"
        :label_ok="confirm_label_ok"
        ></alert>
      <commercial-law-popup :closeModal="closeCommercialLawPopup" :show="show_commercial_law" :tenant="tenant" />
      <confirm-reservation 
        :callback="confirmCallback"
        :callbackComp="completeCallback" 
        :show="confirmReservationShow" 
        :closeModal="closeConfirmReservationPopup"
       />
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Header from "../components/Header.vue";
import Menu from "../components/Menu.vue";
import Alert from "../components/Alert.vue";
import FooterCart from "../components/FooterCart.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { getProvider, getProductsByProvider, getTagsByProvider, isShowFloorGuide } from "../store/firestore";
import Swiper from "swiper";
const $ = window.$;
import PopAlert from "../components/PopAlert.vue";
import CommercialLawPopup from "../components/CommercialLaw.vue";
import ConfirmReservation from "../components/ConfirmReservation.vue";
import dayjs from "dayjs";

export default Vue.extend({
  name: "MobileOrderStoreFront",
  components: {
    'header-app': Header,
    'menu-app': Menu,
    'footer-cart': FooterCart,
    'alert': Alert,
    PopAlert,
    CommercialLawPopup,
    ConfirmReservation
  },
  mixins: [Tenant],
  async created() {
    const shopId = this.$store.state.shopId;
    this.showFloorGuide = await isShowFloorGuide(shopId);
    this.tenantId = this.$route.params.id;
    this.type = this.$route.params.type;
    const tenant = await getProvider(this.tenantId);
    let now = Date.now();
    if (this.type == 'pickup') {
      this.orderType = "モバイルオーダー";
    } else if (this.type == 'reservation') {
      this.orderType == "来店予約";
    } else {
      const orderType = this.type == 'drivethru' ? 'ドライブスルー' : '駐車場受け取り';
      this.orderType = orderType;
    }
    const userId = this.$store.state.userId;
    if (tenant.testuids?.indexOf(userId)){
      now = dayjs().startOf('day').add(1, 'month').valueOf();
    }
    switch(this.type){
      case 'pickup': 
        if ( tenant.handlingFormatToGo && tenant.handlingFormatToGo.enabled) {
          this.baseHandlingFormatSetting = this.getHandlingFormatSetting(tenant, 1);
          // name = "お持ち帰り";
        } else if ( tenant.handlingFormatForHere && tenant.handlingFormatForHere.enabled) {
        this.baseHandlingFormatSetting = this.getHandlingFormatSetting(tenant, 2);
          //name = "店内でお食事";
        }
        //this.baseHandlingFormatSetting = this.getHandlingFormatSetting(tenant, 2);
        if(tenant.pickupDiscloseAt > now){
          await this.confirm("現在モバイルオーダーを提供していません。モバイルオーダートップに戻ります。", true);
          this.$router.push('/mobileorder');
          return;
        }
        this.setting = tenant.pickUp;
        this.backlink = `/mobileorder/${this.type}/shop`;
        break;
      case 'delivery':
      case 'drivethru':
      case 'parkandpickup': 
        if (this.type == 'drivethru') {
          this.baseHandlingFormatSetting = this.getHandlingFormatSetting(tenant, 3);
        } else {
          this.baseHandlingFormatSetting = this.getHandlingFormatSetting(tenant, 4);
        }
        if(tenant.deliveryDiscloseAt > now){
          await this.confirm(`現在${this.orderType}を提供していません。モバイルオーダートップに戻ります。`, true);
          this.$router.push('/mobileorder');
          return;
        }
        this.setting = tenant.delivery;
        this.backlink = `/mobileorder/${this.type}/shop`;
        break;
      case 'reservation':
        this.baseHandlingFormatSetting = this.getHandlingFormatSetting(tenant, 5);
        if(tenant.reservationDiscloseAt > now){
          await this.confirm(`現在${this.orderType}を提供していません。店舗トップに戻ります。`, true);
          this.$router.push('/shop/list?id='+this.tenantId);
          return;
        }
        //カートに来店予約以外が入っている場合はクリア
        if(this.hasNonReservationProductInCart()){
          await this.$store.dispatch('clearCart');
        }
        this.setting = tenant.reservation;
        this.backlink = `/shop/list?id=${this.tenantId}`;
        break;
      default:
        await this.confirm("不正なURLです。モバイルオーダートップに戻ります。", true);
        this.$router.push('/mobileorder');
        break;
    }
    const tags = await getTagsByProvider(this.tenantId);
    let handlingFormats = this.getHandlingFormats(tenant, this.type);
    const products = await getProductsByProvider(this.tenantId, this.type, handlingFormats, this.$store.state.userId);
    tags.map(tag => {
      //console.log(tag.name);
      return tag.products = products.filter(p => p.tags && p.tags.includes(tag.name))
    })
    this.tags = tags.filter(tag => {
      return tag.products && tag.products.length > 0;
    });
    this.tenant = tenant;
    this.products = products.map(product => {
      // リンク無効
      product.description = Common.disabledContentLink(product.description);
      return product;
    })
    this.acceptTime = this.calcAcceptTime(tenant, this.type);
    this.dataReady = true;
    let initialSlide = parseInt(this.initialTab);
    if(!initialSlide){
      initialSlide = 0;
    }
    var _this = this;

    function setCurrentSlide(ele, index) {
      $(".js-swiper_tab .swiper-slide").removeClass("is-active");
      ele.addClass("is-active");
    }

    this.$nextTick(() => {
      var swiper_tab = new Swiper('.js-swiper_tab', {
        initialSlide: initialSlide,
        slidesPerView: 'auto',
        paginationClickable: true,
        freeMode: true,
        loop: false,
        onTab: function (swiper) {
          var n = swiper_tab.clickedIndex;
        }
      });

      $.each(swiper_tab.slides, function (index, val) {
        var ele = $(this);
        ele.on("click", function () {
          setCurrentSlide(ele, index);
          if(index != _this.$route.query.tab){
            _this.$router.push({ query: { tab: index } });
          }
          swiper_tab_body.slideTo(index, 500, false);
        });
      });

      var swiper_tab_body = new Swiper('.js-swiper_tab_body', {
        initialSlide: initialSlide,
        direction: 'horizontal',
        loop: false,
        autoHeight: true,
        on: {
          slideChangeTransitionEnd: function () {
            if(!swiper_tab_body) return;
            var n = swiper_tab_body.activeIndex;
            setCurrentSlide($(".js-swiper_tab .swiper-slide").eq(n), n);
            swiper_tab.slideTo(n, 500, false);
            if(n != _this.$route.query.tab){
              _this.$router.push({ query: { tab: n } });
            }
          },
        }
      });

      setCurrentSlide($(".js-swiper_tab .swiper-slide").eq(initialSlide), initialSlide);

      _this.swiper_tab_body = swiper_tab_body;
      _this.swiper_tab = swiper_tab;
    });
  },
  data() {
    return {
      tenant: undefined,
      type: undefined,
      products: undefined,
      tags: undefined,
      setting: undefined,
      dataReady: false,
      acceptTime: undefined,
      orderType: undefined,
      swiper_tab_body: undefined,
      swiper_tab: undefined,
      show_commercial_law: false,
      initialTab: Common.getUrlParam('tab') || 0,
      backlink: undefined,
      baseHandlingFormatSetting: null,
      show_more_detail:false,
      confirmReservationShow: null,
      showFloorGuide: false
    }
  },
  mounted() {
    Common.initDom();

    
  },
  methods: {
    getPrice(product) {
      const handlingFormats = this.getHandlingFormatType(this.type, this.tenant);
      const taxRateType = this.getTaxRateType(handlingFormats.handlingFormatDef, handlingFormats.number == 2 ? 1 :2);
      let price = this.getUnitPrice(product, taxRateType, "excluded");
      return price ? price : 0;
    },
    showDetailMore(val) {
      this.show_more_detail = val;
    },
    openCommercialLawPopup() {
      this.show_commercial_law = true;
    },
    closeCommercialLawPopup() {
      this.show_commercial_law = false;
    },
    redirectToProductDetail(productId) {
      this.$router.push(`/mobileorder/shop/${this.tenantId}/${this.type}/${productId}`);
    },
    getShopImage() {
      let image = this.tenant.image[0];

      if (
        (this.type == 'pickup' && this.tenant.handlingFormatToGo && this.tenant.handlingFormatToGo.enabled) ||  //お持ち帰り
        (this.type == 'pickup' && this.tenant.handlingFormatForHere && this.tenant.handlingFormatForHere.enabled)) { //店内でお食事
        if (this.tenant.pickupImage) {
          image = this.tenant.pickupImage;
        }
      } else 
      if (
        (this.type == 'drivethru' && this.tenant.handlingFormatDeliveryLane && this.tenant.handlingFormatDeliveryLane.enabled) || //ドライブスルー
        (this.type == 'parkandpickup' && this.tenant.handlingFormatDeliveryParking && this.tenant.handlingFormatDeliveryParking.enabled)) {  //駐車場受け取り
        if (this.tenant.deliveryImage) {
          image = this.tenant.deliveryImage;
        }
      } else
      if (this.type == 'reservation' && this.tenant.handlingFormatReservation && this.tenant.handlingFormatReservation.enabled) { //ご来店予約
        if (this.tenant.reservationImage) {
          image = this.tenant.reservationImage;
        }
      }

      
      
      return image;
    },
    async showOption(productId) {
      if (!this.isReservation()) return false;
      if (this.isOrderEnabled(this.tenant, this.type)) {
        this.$router.push(`/mobileorder/shop/${this.tenantId}/${this.type}/${productId}/option`);
      } else {
        await this.confirm("ただいまの時間は受け付けておりません。", true);
      }
    },
    async showSoldout() {
      await this.confirm("この商品は現在売り切れのためご注文いただけません。", true);
    },
    isPriceNoticeRequired(tenant){
      //「商品提供方法がお持ち帰りの場合、容器代等が加わり商品単価が変わります」
      return tenant && tenant.shopCategoryType == 5 
        && tenant?.handlingFormatToGo?.enabled 
        && tenant?.handlingFormatForHere?.enabled;
    },
    hasNonReservationProductInCart() {
      return Object.values(this.$store.state.cart)
        .map(item => item.orderType)
        .filter(item => item != 3)?.length || 0;
    },
    checkShowItem(tenant,product) {

      if (this.type == 'reservation') {
        //有料来店予約対応
        //商品を出さないとき
        //paidReservationEnabledがtrueの場合
        if (!tenant.paidReservationEnabled && this.getPrice(product) > 0) {
        //ReservationEnabledがtrueのときだけ金額がある商品を表示
        //時間指定予約じゃない場合も出さない
          return false;
        }

        //商品一覧でrequiredTimeが0とかnullの場合は表示しない
        if (tenant.enableTimebaseReservation) {
          if (product.requiredTime == 0 || product.requiredTime == null) {
            return false;
          }        
        }
      }

      if (this.type == 'pickup') {
        if (tenant.enableTimebasePickup) {
          if (product.requiredTime == 0 || product.requiredTime == null) {
            return false;
          }        
        }
      }
      

      return true;
    },
    isEnableTimebase(tenant) {
      const type = this.getOrderType();

      if ((type == 1 && tenant.enableTimebasePickup) || (type == 3 && tenant.enableTimebaseReservation)) {
        return false;
      } 
      return true;
    },
    isReservation() {
      //来店予約でかつ商品が存在する場合
      const cartData = {...this.$store.state.cart};
      for (const [key, tenantCart] of Object.entries(cartData)) {
        if (tenantCart && tenantCart.orderType == 3) {
          this.confirmReservationShow = true;
          return false;
        }
      }
      return true;
    },
  closeConfirmReservationPopup() {
    this.confirmReservationShow = false;
  },
  completeCallback() {
    this.$router.push('/mobileorder/checkout');
  },
  getOrderType(){
      switch(this.type){
        case 'pickup':
          return 1;
        case 'delivery':
        case 'drivethru':
        case 'parkandpickup':
          return 2;
        case 'reservation':
          return 3;
        default:
          //nothing
      }
    },
    // カートクリア
    async confirmCallback() {
      let orderType = this.getOrderType();
      if (this.tenantId && orderType == 3) {
        //来店予約の時にカート情報消して詳細画面戻る
        await this.$store.dispatch('clearCart');
        if (this.$router.history.current.path != `/mobileorder/shop/${this.tenantId}/reservation`) {
          this.$router.push(`/mobileorder/shop/${this.tenantId}/reservation`);
        } 
      } else {
        this.backPagePrevious();
      }    
    }
  },
})
</script>